module.exports = __webpack_public_path__ + "static/media/Collaboration.66125be6.svg";